// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2YSIM","imageUploader":"EGiftCard_imageUploader__Bb4Ur"};